import React from "react";

export default function CalendarFilters({ filter, onFilterChange, slotMinutes, onSlotMinutesChange, workingToday = false, onWorkingTodayChange, showAvailable = false }) {
  const options = [["all", "All"], ["availability", "Working hours"], ["appointment", "Appointments"], ["block", "Blocked time"]];
  if (showAvailable) options.splice(2, 0, ["available", "Available"]);
  return <div className="schedule-calendar-filters">
    <div className="schedule-calendar-filter-group">
      <div className="schedule-segments" aria-label="Show calendar items">
        {options.map(([value, label]) =>
          <button key={value} type="button" aria-pressed={filter === value} onClick={() => onFilterChange(value)}>
            {value !== "all" && <span aria-hidden="true" className={`schedule-type-swatch ${value}`} />}{label}
          </button>)}
      </div>
      {onWorkingTodayChange ? (
        <button type="button" className="schedule-working-today" aria-pressed={workingToday}
          onClick={() => onWorkingTodayChange(!workingToday)}>
          Working today
        </button>
      ) : null}
    </div>
    {onSlotMinutesChange ? <label className="schedule-grid-select">Time intervals<select value={slotMinutes} onChange={(event) => onSlotMinutesChange(Number(event.target.value))}>
      {[5, 10, 15, 20, 30, 60].map((minutes) => <option key={minutes} value={minutes}>{minutes} min</option>)}
    </select></label> : null}
  </div>;
}
